import { AuthorNotificationsSidebar } from './AuthorNotificationsSidebar';
import { UserNotificationsSidebar } from './UserNotificationsSidebar';

type Props = {
  mode: 'author' | 'user';
};

export const NotificationsSidebar = ({ mode }: Props) => {
  return mode === 'author' ? (
    <AuthorNotificationsSidebar />
  ) : (
    <UserNotificationsSidebar />
  );
};
